import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface SophosRequestImpl {
    readonly sophos_client_id: string;
    readonly sophos_client_secret: unknown;
}
interface SophosCreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly throttling_allowed: boolean;
    readonly name: string;
    readonly sophos_client_id: string;
    readonly sophos_client_secret: unknown;
    readonly ingest_alerts: boolean;
    readonly polling_interval: number;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: SophosRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.sophos.api.SophosResource/sophos/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Sophos input
 */
export function create(JSONbody: SophosCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.sophos.api.SophosResource/sophos/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
